// extracted by mini-css-extract-plugin
module.exports = {"sidePanel":"InferenceInspectorPage-styles-module--sidePanel--AIaVN"};